"use strict";
exports.__esModule = true;
exports.global_Color_dark_100 = {
  "name": "--pf-v5-global--Color--dark-100",
  "value": "#151515",
  "var": "var(--pf-v5-global--Color--dark-100)"
};
exports["default"] = exports.global_Color_dark_100;